import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { FormModal } from '../../Form'

import { REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_QA_NAME } from './RequestEditApplicantAddressModal.constants'
import {
  getRequestEditApplicantAddressModalPayload,
  getRequestEditApplicantAddressModalValidationSchema,
} from './RequestEditApplicantAddressModal.utils'
import { RequestEditApplicantAddressModalFields } from './RequestEditApplicantAddressModalFields'

function RequestEditApplicantAddressModal({
  focusFieldName,
  initialValues,
  onSubmit,
  ...restProps
}) {
  const formBodyProps = {
    submitQaName: QA_NAME_SAVE_BTN,
    withNotifications: true,
  }

  const validationSchema = getRequestEditApplicantAddressModalValidationSchema({
    initialValues,
  })

  function handleSubmit({ values }) {
    onSubmit({
      payload: getRequestEditApplicantAddressModalPayload(values),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={RequestEditApplicantAddressModalFields}
      containerProps={{
        qaName: REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_QA_NAME,
      }}
      formBodyProps={formBodyProps}
      formFieldsProps={{ focusFieldName }}
      formTitle='Modal.RequestProfileEditOwnerAndAddressModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditApplicantAddressModal
